module.exports = __webpack_public_path__ + "static/media/26.aed32f2b.jpg";